import { Outlet } from 'react-router-dom'
import {
  CssBaseline,
  Box,
  Stack,
  styled,
  useTheme,
  useMediaQuery,
} from '@mui/material'
import { Header } from './components/Header'
import SideNav from './components/SideNav/SideNav'
import { useDynamicHeader } from '../providers'

const LayoutContainer = styled(Box)`
  display: flex;
  min-height: 100vh;
  /* TODO: grab from theme */
  background-color: #f7f7f7;
  ${({ theme }) => `
    // background-color: ${theme.palette.background.default};
    color: ${theme.palette.text.primary};
  `}
`

export const Layout = ({ children }) => {
  const { headerTitle, actionButton, showGoBack, goBackUrl } =
    useDynamicHeader()

  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'))

  return (
    <LayoutContainer>
      <CssBaseline />
      <SideNav />
      <Stack overflow={'hidden'} flexGrow={1} flexDirection="column">
        <Header
          title={headerTitle}
          actionButton={actionButton}
          showGoBack={showGoBack}
          goBackUrl={goBackUrl}
        />
        <Box
          sx={{
            padding: '16px',
            height: 'calc(100vh - 75px)',
            overflow: isSmallScreen ? 'auto' : 'unset',
          }}
        >
          {children}
          {/* <Outlet /> */}
        </Box>
      </Stack>
    </LayoutContainer>
  )
}
